import { useEffect, useState, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useSubscription } from 'context/SubscriptionContext';
import { fInitSMAuth, checkAnySMConnected } from 'lib/appFx';
//import SocialNetworkCard from 'sections/widgets/sMediaWidget/SocialNetworkCard';
//import SocialNetworkCard2 from './SocialNetworkCard2';
import SocialNetworkCard3 from './SocialNetworkCard3';
import Modal from 'core/Modal';
import { getSMediaMgr } from 'services/sMediaApi';
//---------------------------------------------------------

export default function SocialMediaConnectModal({
	sMediaMethods,
	uFeedFilter, setUFeedFilter, forceOpen=false, setForceOpen=null
}) {
	const redSMMgr = useSelector(getSMediaMgr);
	//redSMMgr && console.log('redSMMgrM22', redSMMgr);
	let sMConnModal, allConnMsg;
	
	// Get subscription status from context
	const { hasActiveSubscription, isEligibleForSubscriptionCheck } = useSubscription();
	
	// Determine if modal should be shown based on subscription status
	// Only show modal if user has active subscription or is not eligible for subscription checks
	const shouldShowModal = !isEligibleForSubscriptionCheck || hasActiveSubscription;

	const [open, setOpen] = useState(false);
	const [shownModal, setShownModal] = useState(false);
	const handleClose = () => {
		setOpen(false);
		setShownModal(true);
		forceOpen && setForceOpen(false);
	};//console.log('shownModal', shownModal);
	const location = useLocation();
	const { pathname } = location;
	const isHomePage = useCallback(() => {
		return ['/home', '/', ''].includes(pathname);
	}, [pathname]);
	//console.log('redSMMgrModal', redSMMgr);

	//const fFOpen = () => { console.log('Hello'); setOpen(true); }
	//if(forceOpen && isHomePage()) { setOpen(true);}

	const fCheckShowModal = useCallback(
		() => {
			if(redSMMgr) {
				const anySMConnected = checkAnySMConnected(redSMMgr);
				//console.log('redSMMgr '+anySMConnected, redSMMgr);
				if(!anySMConnected) {
					/*allConnMsg = [
						"Please connect your ",
						<br key="nLBrUReg" />,
						"social media accounts",//"social media account(s)",
					];*/
				
					// Only show modal if user should see it based on subscription status
					if(!shownModal && isHomePage() && shouldShowModal) {
						if(!open) { setOpen(true); }
					}
				}
			}
		}
	, [isHomePage, setOpen, open, shownModal, redSMMgr, shouldShowModal]);

	useEffect(()=> { setTimeout(() => {
		fCheckShowModal()}, 100);
	}, [fCheckShowModal]);
	useEffect(()=> {forceOpen && isHomePage() && shouldShowModal && setOpen(true);}, [forceOpen, setOpen, shouldShowModal]);
	//console.log('fFOpen '+forceOpen+' '+open, typeof setForceOpen);

	sMConnModal = (//(//keepMounted disableEnforceFocus hideBackdrop={true});
		<Modal onClose={handleClose} open={open}>
			<SocialNetworkCard3
				sMediaMethods={sMediaMethods}
				onClose={handleClose}
				//setOpen={setOpen} setShownModal={setShownModal}
				uFeedFilter={uFeedFilter}
				setUFeedFilter={setUFeedFilter}
			/>
		</Modal>
	);
	//---------------------------------------------------------

	return <>{sMConnModal}</>;
};